import { CircularTerm, FinanceCircular } from '../types/catalog';

// Circular Peugeot — jueves 1 de octubre de 2026. Cuota cada $1.000.
// "Quebranto IVA incluido" se guarda como dato interno (no se muestra al público).

const t = (term: number, tna: number, dealerContributionPct: number, installmentPer1000: number): CircularTerm => ({
  term,
  tna,
  dealerContributionPct,
  installmentPer1000,
});

export const peugeotCircular: FinanceCircular = {
  brandId: 'peugeot',
  lender: 'PSA Finance Argentina',
  reference: 'Circular Peugeot · 1 de octubre de 2026',
  validFrom: '2026-10-01',
  validUntil: '2026-10-31',
  managementFeePct: null,
  notes: ['La cuota no incluye seguro automotor.', 'Sujeto a aprobación crediticia.'],
  lines: [
    {
      id: 'peugeot-tasa-express-18',
      name: 'Tasa Express',
      detail: 'Toda la gama',
      maxAmount: 18000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [t(12, 0, 12, 83.33), t(18, 0, 15, 55.56), t(24, 9.9, 15, 47.83), t(36, 19.9, 15, 40.6), t(48, 24.9, 15, 37.46)],
    },
    {
      id: 'peugeot-gama-26',
      name: 'Tasa fija Peugeot',
      detail: 'Toda la gama',
      maxAmount: 26000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [t(12, 4.9, 14, 86.42), t(18, 14.9, 14, 64.95), t(24, 22.9, 14, 56.33), t(36, 26.9, 14, 45.48), t(48, 29.9, 14, 41.18), t(60, 29.9, 14, 37.52)],
    },
    {
      id: 'peugeot-prendario-uva-26',
      name: 'Prendario UVA',
      detail: 'Toda la gama',
      maxAmount: 26000000,
      models: 'all',
      rateType: 'uva',
      audience: 'general',
      channel: 'TRAD',
      terms: [t(12, 0, 9, 83.33), t(24, 0, 14, 41.67), t(36, 7.9, 14, 32.67), t(48, 11.9, 14, 28.37)],
    },
    {
      id: 'peugeot-gama-36',
      name: 'Tasa fija Peugeot',
      detail: 'Toda la gama',
      maxAmount: 36000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [t(12, 13.9, 12, 92.17), t(18, 23.9, 12, 70.84), t(24, 27.9, 12, 59.72), t(36, 33.9, 12, 50.55), t(48, 35.9, 12, 45.8)],
    },
    {
      id: 'peugeot-premium-45',
      name: 'Tasa fija Peugeot',
      detail: 'Boxer, 5008, 3008 y 408',
      maxAmount: 45000000,
      models: ['Boxer', '5008', '3008', '408'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [t(12, 13.9, 12, 92.17), t(18, 23.9, 12, 70.84), t(24, 27.9, 12, 59.72), t(36, 33.9, 12, 50.55), t(48, 35.9, 12, 45.8)],
    },
    {
      id: 'peugeot-ve-40',
      name: 'Línea V.E.',
      detail: 'Expert, Boxer, 408, 3008 y 5008',
      maxAmount: 40000000,
      models: ['Expert', 'Boxer', '408', '3008', '5008'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [t(12, 23.5, 12, 92.17), t(24, 34.5, 12, 59.72), t(36, 36.5, 12, 50.55)],
    },
    {
      id: 'peugeot-ve-408-5008',
      name: 'Línea V.E.',
      detail: '408 y 5008',
      maxAmount: 40000000,
      models: ['408', '5008'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [t(24, 9.9, 16, 47.83)],
    },
  ],
};
